import { render, staticRenderFns } from "./ArchivesByCategory.vue?vue&type=template&id=02576246&"
import script from "./ArchivesByCategory.vue?vue&type=script&lang=js&"
export * from "./ArchivesByCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports